"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkWinner = exports.getWinners = exports.moveOpponent = void 0;
var assert_1 = __importDefault(require("assert"));
var models_1 = require("./models");
function moveOpponent(board, movedToken) {
    var _a = movedToken.from, row = _a.row, col = _a.col;
    var focusedToken = board[row][col].token;
    var targetSpace = board[movedToken.to.row][movedToken.to.col];
    (0, assert_1.default)(targetSpace.token === models_1.Token.Empty, 'the target space must be empty');
    switch (focusedToken) {
        case models_1.Token.Empty: throw new Error('cannot move token from an empty space');
        default: {
            return board.map(function (r, rIndex) { return r.map(function (c, cIndex) {
                if (rIndex === row && cIndex === col)
                    return __assign(__assign({}, c), { token: models_1.Token.Empty });
                if (rIndex === movedToken.to.row && cIndex === movedToken.to.col)
                    return __assign(__assign({}, c), { token: focusedToken });
                return c;
            }); });
        }
    }
}
exports.moveOpponent = moveOpponent;
// this function will check for winners in the board, which means it can handle ties
var getWinners = function (board, players) {
    var maybeRedWinner = (0, exports.checkWinner)(board, models_1.Token.Red);
    var maybeBlueWinner = (0, exports.checkWinner)(board, models_1.Token.Blue);
    var token = maybeRedWinner ? [].concat(models_1.Token.Red) : [];
    var winningTokens = maybeBlueWinner ? token.concat(models_1.Token.Blue) : token;
    var mappedPlayers = winningTokens.map(function (token) { return players.find(function (player) { return player.token === token; }); });
    return new Set(mappedPlayers);
};
exports.getWinners = getWinners;
var checkWinner = function (board, checking) {
    var size = board.length;
    // Check rows
    for (var i = 0; i < size; i++) {
        if (board[i].every(function (cell) { return cell.token === checking; })) {
            return true;
        }
    }
    var _loop_1 = function (i) {
        if (board.every(function (row) { return row[i].token === checking; })) {
            return { value: true };
        }
    };
    // Check columns
    for (var i = 0; i < 4; i++) {
        var state_1 = _loop_1(i);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    // Check diagonals
    if (board.every(function (row, i) { return row[i].token === checking; })) {
        return true;
    }
    if (board.every(function (row, i) { return row[3 - i].token === checking; })) {
        return true;
    }
    return false;
};
exports.checkWinner = checkWinner;
